module.exports = __webpack_public_path__ + "img/465.37e49fdb.jpg";